import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Link from '@zg-rentals/multibrand-ui/lib/Link';

const propTypes = {
    onAdClick: PropTypes.func.isRequired,
    insertionOrderId: PropTypes.number.isRequired,
};

class BoostAdPreviewLink extends React.Component {
    constructor(props) {
        super(props);
        this.handleLinkClick = this.handleLinkClick.bind(this);
    }

    handleLinkClick(e) {
        e.preventDefault();
        this.props.onAdClick(this.props.insertionOrderId);
    }

    render() {
        return (
            <Link onClick={this.handleLinkClick}>
                View ad
            </Link>
        );
    }
}

BoostAdPreviewLink.propTypes = propTypes;

export default BoostAdPreviewLink;
